import UrlCache from '@/modules/backstage/components/UrlCache';
import RouteResolve from '@/modules/backstage/components/RouteResolve';

const components = [
  {
    title: 'message.backstage.cache.title',
    icon: 'cached',
    component: UrlCache,
  },
  {
    title: 'message.backstage.route.title',
    icon: 'routes',
    component: RouteResolve,
  },
];

export default {
  components,
};
